import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MojoAvatarModule } from 'mojo-avatar';
import { MojoCardModule } from 'mojo-card';
import { MojoFeatureExtensionsModule } from 'mojo-feature-extensions';
import { FeatureFlagsDirectiveModule } from 'mojo-feature-flags';
import { MojoPrivilegesModule } from 'mojo-privileges';
import { MojoProfileCardModule } from 'mojo-profile-card';

import { AssignsButtonsModule } from '@app/modules/assigns/containers/buttons+/assigns-buttons.module';
import { CandidateProfileCardComponent } from '@modules/candidates/components/candidate-profile-card/candidate-profile-card.component';
import { SharedModule } from '@shared';
import { BadgesModule } from '@shared/candidate-badges/candidate-badges.module';
import { CandidateModule } from '@shared/candidate/candidate.module';
import { ResumeLinkModule } from '@shared/resume-link/resume-link.module';
import { SocialLinksModule } from '@shared/social-links/social-links.module';

import { CandidateLabelComponent } from './candidate-label/candidate-label.component';
import { CandidateRankComponent } from './candidate-rank/candidate-rank.component';
import { ComponentsConfig } from './components.abstract.config';
import { componentsConfig } from './components.config';
import { HeaderComponent } from './header/header.component';
import { JobComponent } from './job/job.component';
import { PercentileComponent } from './percentile/percentile.component';

const components = [
  CandidateLabelComponent,
  CandidateRankComponent,
  HeaderComponent,
  JobComponent,
  PercentileComponent,
  CandidateProfileCardComponent,
];

@NgModule({
  declarations: [...components],
  imports: [
    SharedModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    AssignsButtonsModule,
    MojoPrivilegesModule,
    MojoCardModule,
    MojoFeatureExtensionsModule,
    BadgesModule,
    ResumeLinkModule,
    SocialLinksModule,
    CandidateModule,
    MojoAvatarModule,
    MojoProfileCardModule,
    FeatureFlagsDirectiveModule,
  ],
  exports: [...components, SocialLinksModule],
  providers: [
    {
      provide: ComponentsConfig,
      useValue: componentsConfig,
    },
  ],
})
export class CandidatesComponentsModule {}
